import { useServices } from "@core/servicesContext";
import { PromiseResult, usePromise } from "@utils/hooks";
import { CurrencyCode, CurrencyConversion } from "./currency";

export function useConversion(baseCurrency: CurrencyCode, value: number): PromiseResult<Partial<CurrencyConversion>> {
	const { currencyService } = useServices();

	return usePromise(() => currencyService.getConversion(baseCurrency, value), [baseCurrency, value]);
}
